<div class="page" id="page_packages">
    <div class="container">

        <h2 class="section-title">PACOTES</h2>
        <p>
            Planos simples, sem surpresas <br/>
            Monte um plano especifico para você
                
        </p>
<!-- 
        <div class="section-divider"></div>
        <br/><br/> -->

        <section class="section" id="planos">
            <div class="section-shell pricing-shell">
                


                <!-- <div class="billing-switch" aria-label="Periodo de cobranca">
                    @for (item of plans; track item.name) {
                    <button
                        type="button"
                        [class.is-active]="billingCycle() === item.type"
                        (click)="setBillingCycle(item.type)"
                    >
                        {{ item.name }}
                    </button>
                    }
                </div>

                <article class="surface-card pricing-card">
                    @for (item of plans; track item.name) {
                    <div [class.off]="billingCycle() !== item.type">
                        <span class="pricing-card__plan" [class.off]="billingCycle() !== item.type">
                        {{ 'Plano ' + item.name }}
                        </span>
                        <!- <h3>{{ displayPrice() }}</h3> ->
                        <h3>R$ {{ item.price }}</h3>
                        <p>{{ priceNote() }}</p>
                        <a class="button button--primary" href="#lead-form">Assinar agora</a>
                    </div>
                    }
                    <ul class="pricing-card__list">
                    <li>Cadastro e histórico de encomendas</li>
                    <li>Fluxo de notificação para moradores</li>
                    <li>Visão operacional para portaria e gestão</li>
                    <li>Implantação assistida</li>
                    </ul>
                </article> -->
                
            </div>
        </section>

        <div class="section-divider"></div>

        <div class="page-footer">
            <h4>AGENDE UMA AULA EXPERIMENTAL</h4>
            
            <a class="btn primary-line" 
                target="_blank"  
                href="https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, gostaria de obter informações sobre a New Fit Performance Club"
                (click)="navigate('joinus')">
                <span>AGENDAMENTOS </span>
                <fa-icon [icon]="faWhatsapp" />
            </a>
        </div>

        <div class="section-divider"></div>

    </div>
</div>